import React from 'react';
import {
  List,
  Show,
  Create,
  Edit,
  Datagrid,
  TextField,
  EmailField,
  ReferenceField,
  TextInput,
  SimpleForm,
  SimpleShowLayout,
  ShowButton,
  EditButton,
  SelectInput,
  ReferenceInput,
  DateField,
  required,
} from 'react-admin';
import { parse } from 'qs';
import Icon from '@material-ui/icons/Phone';
import Title from './Title';

export const ContactInfoIcon = Icon;

// const ContactInfoFilter = props => (
//   <Filter {...props}>
//     <TextInput label="Search" source="q" alwaysOn />
//     <ReferenceInput label="Car Model" source="name" allowEmpty>
//       <SelectInput optionText="name" />
//     </ReferenceInput>
//   </Filter>
// );

const keys = [
  { id: 'general', name: 'General Enquiries' },
  { id: 'service', name: 'Service' },
  { id: 'assistance', name: 'Roadside Assistance' },
];

const validateMobile = values => {
  const errors = {};
  if (values.mobile && !values.mobile.startsWith('+')) {
    errors.mobile = ['Mobile should start with +'];
  }
  return errors;
};

export const ContactInfoList = props => (
  <List {...props} title="Contact Infos">
    <Datagrid>
      <ReferenceField label="Car Brand" sortBy="car_brands.name" source="car_brand_id" reference="brands">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="name" />
      <TextField source="mobile" />
      <EmailField source="email" />
      <ShowButton />
      <EditButton />
    </Datagrid>
  </List>
);

export const ContactInfoShow = props => (
  <Show {...props}>
    <SimpleShowLayout>
      <ReferenceField label="Car Brand" source="car_brand_id" reference="brands">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="name" />
      <TextField source="mobile" />
      <EmailField source="email" />
      <DateField label="Created date" showTime={true} source="created_at" />
      <DateField label="Updated date" showTime={true} source="updated_at" />
    </SimpleShowLayout>
  </Show>
);

export const ContactInfoCreate = props => {
  const query = parse(props.location.search, { ignoreQueryPrefix: true });
  let redirect = 'edit',
    brand_id = '';
  if (query.brand_id) {
    brand_id = parseInt(query.brand_id, 10);
    redirect = `/brands/${brand_id}/2`;
  }

  return (
    <Create title={'New Contact Info'} {...props}>
      <SimpleForm validate={validateMobile} redirect={redirect} defaultValue={{ car_brand_id: brand_id }}>
        <ReferenceInput source="car_brand_id" reference="brands" validate={required()} perPage={-1}>
          <SelectInput optionText="name" />
        </ReferenceInput>
        <SelectInput source="type" choices={keys} validate={required()} />
        <TextInput source="mobile" validate={required()} />
        <TextInput source="email" />
      </SimpleForm>
    </Create>
  );
};

export const ContactInfoEdit = props => {
  const query = parse(props.location.search, { ignoreQueryPrefix: true });
  let redirect = 'list',
    brand_id = '';
  if (query.brand_id) {
    brand_id = parseInt(query.brand_id, 10);
    redirect = `/brands/${brand_id}/2`;
  }

  return (
    <Edit title={<Title />} {...props}>
      <SimpleForm redirect={redirect} validate={validateMobile}>
        <ReferenceInput source="car_brand_id" reference="brands" validate={required()} perPage={-1}>
          <SelectInput optionText="name" />
        </ReferenceInput>
        <SelectInput source="type" choices={keys} validate={required()} />
        <TextInput source="mobile" validate={required()} />
        <TextInput source="email" />
      </SimpleForm>
    </Edit>
  );
};



// WEBPACK FOOTER //
// ./src/containers/ContactInfo/index.js